const safeGa = (...args) => (window.ga ? window.ga(...args) : null);
export default safeGa;



// WEBPACK FOOTER //
// ./src/modules/safeGa.js